const state = {
  enabled: false,
}

const getters = {

}

const mutations = {
  setMode(state, mode) {
    document.body.classList.add('theme-in-transition')
    state.enabled = mode
    localStorage.setItem('theme', mode ? 'dark' : 'light')
    if (mode) {
      document.body.setAttribute('data-theme', 'dark')
    } else {
      document.body.setAttribute('data-theme', 'light')
    }
    setTimeout(() => {
      document.body.classList.remove('theme-in-transition')
    }, 450)
  },
}

const actions = {
  init({ commit }) {
    const theme = localStorage.getItem('theme')
    commit('setMode', theme === 'dark')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/app/DarkMode.js